export const TermTypes = Object.freeze({
  sixMonthsOrLess: 6,
  twelveMonths: 12,
  twentyFourMonths: 24,
  threeYears: 36,
  fourFiveYears: 54,
  moreThanFiveYears: 60,
});

export const TermTypesLabels = Object.freeze({
  [TermTypes.sixMonthsOrLess]: '6 months or less',
  [TermTypes.twelveMonths]: '12 months',
  [TermTypes.twentyFourMonths]: '24 months',
  [TermTypes.threeYears]: '3 years',
  [TermTypes.fourFiveYears]: '4-5 years',
  [TermTypes.moreThanFiveYears]: 'More than 5 years',
});

export const toOptions = () =>
  Object.values(TermTypes).map((value) => ({ label: TermTypesLabels[value], value }));
